(function($) {

	$.fn.outerHtml = function(s) {
		return $('<div>').append( this.eq(0).clone() ).html();
	};

})(jQuery);